export default function (props: { title: string }) {
  return h('h2', { class: 'mb-[20px] font-bold text-[22px] tabletl:text-[26px] text-center text-[#fff] tracking-wider' }, props.title)
}
